import { API_PATH } from 'config';

// Resuelve un asset servido por el API (ej. el logo del tenant, que el backend
// devuelve como `/api/v1/tenants/:id/logo-file`) a una URL que el navegador
// pueda pedir desde cualquier origen.
//
// El backend devuelve un path relativo porque el bucket S3 es privado y no
// existe URL pública del objeto: los bytes salen por un endpoint proxy. Ese
// path funcionaba mientras el front y el API compartían dominio, pero en
// producción el front vive en el dominio del tenant (proliftapp.cl) y el API
// en api.stiltech.cl. Al usarlo tal cual en un `<img src>`, el navegador lo
// resuelve contra el origen de la página y termina pidiéndoselo a Cloudflare
// Pages, cuyo fallback de SPA responde index.html con 200 — la imagen no
// carga y no hay error visible en la consola.
//
// Reglas:
//   - null/undefined/"" → null (no hay asset que mostrar).
//   - http(s)://... → se usa tal cual (logos legacy con URL absoluta).
//   - API_PATH relativo (desarrollo, mismo origen vía proxy de Vite) → el path
//     se devuelve intacto.
//   - API_PATH absoluto (producción) → se resuelve contra el origen del API.
//     Se usa solo el origin, nunca se concatena API_PATH completo, porque el
//     path ya trae su propio prefijo `/api/v1` y se duplicaría.
export function apiAssetUrl(raw) {
  if (!raw) return null;
  if (/^https?:\/\//.test(raw)) return raw;

  const base = API_PATH || '';
  if (!/^https?:\/\//.test(base)) return raw;

  try {
    return new URL(raw, new URL(base).origin).toString();
  } catch {
    return raw;
  }
}

export default apiAssetUrl;
